import { FieldInputProps, FieldMetaProps, useField } from "formik";

interface UseInput<Value> {
  hasError: boolean;
  field: FieldInputProps<Value>;
  meta: FieldMetaProps<Value>;
}

const useInput = <T = string>(name: string): UseInput<T> => {
  const [field, meta] = useField(name);
  const hasError = !!(meta.touched && meta.error);

  return { field, meta, hasError };
};

export default useInput;
